import React, { FC } from "react";

import { Popover } from "@amphore-dev/amphore-lib";

import { TPopoverSelectOption } from "@/components/molecules/PopoverSelect/PopoverSelect";

export interface IBreadcrumbSelectProps<T = unknown> {
	options: TPopoverSelectOption<T>[];
	value?: string | number | null;
	onChange: (value: string | number | null) => void;
	allLabel?: string;
}

export const BreadcrumbSelect: FC<IBreadcrumbSelectProps> = <T,>({
	options = [],
	value,
	onChange,
	allLabel,
}: IBreadcrumbSelectProps<T>) => {
	const selected = options.find(
		(opt) => opt.value?.toString() === value?.toString()
	);

	const label = selected?.label ?? allLabel;

	return (
		<Popover
			content={
				<div className="flex min-w-35 flex-col gap-1">
					{allLabel && (
						<>
							<button
								className="w-full rounded-sm px-2 py-1 text-left text-sm text-neutral-500 hover:bg-neutral-100"
								onClick={() => onChange(null)}
							>
								{allLabel}
							</button>
							<div className="my-0.5 border-t border-neutral-100" />
						</>
					)}
					{options.map((option) => (
						<button
							key={option.value}
							className="flex w-full items-center gap-2 rounded-sm px-2 py-1 text-left text-sm hover:bg-neutral-100"
							onClick={() => onChange(option.value)}
						>
							{option.color && (
								<span
									className="h-2 w-2 shrink-0 rounded-full"
									style={{ backgroundColor: option.color }}
								/>
							)}
							{option.label}
						</button>
					))}
				</div>
			}
			className="p-1!"
			closeOnClick
		>
			<button
				type="button"
				className="flex max-w-full min-w-0 items-center gap-1"
			>
				{selected?.color && (
					<span
						className="inline-block h-2 w-2 shrink-0 rounded-full"
						style={{ backgroundColor: selected.color }}
					/>
				)}
				<span className="max-w-40 truncate sm:max-w-64">{label}</span>
			</button>
		</Popover>
	);
};
